/**
 * 字段类型
 * @author wangjiegj<wangjiegj@inspur.com>
 */

import {I18nUtil} from "../../../i18n/i18n-service";

/**
 * 字段类型
 */
enum GSPElementObjectType {
    /**
     * 未设置
     */
    None = 'None',

    /**
     * 关联
     */
    Association = 'Association',

    /**
     * 枚举
     */
    Enum = 'Enum',

    /**
     * 动态属性
     */
    DynamicProp = 'DynamicProp',
    /**
     * 公共帮助
     */
    PublicHelp = "PublicHelp"
}

export { GSPElementObjectType };

export const GSPElementObjectTypes: Array<{ index: number, text: string, value: GSPElementObjectType }> = [
    { index: 0, text: I18nUtil.instant("None"), value: GSPElementObjectType.None },
    { index: 1, text: I18nUtil.instant("Association"), value: GSPElementObjectType.Association },
    { index: 2, text: I18nUtil.instant("Enum"), value: GSPElementObjectType.Enum },
    { index: 3, text: I18nUtil.instant("DynamicProp"), value: GSPElementObjectType.DynamicProp },
    { index: 4, text: I18nUtil.instant("PublicHelp"), value: GSPElementObjectType.PublicHelp }
];
export class GetElementObjTypesUtil {
    static GSPElementObjectTypesWithouDynamic(): Array<{ index: number, text: string, value: GSPElementObjectType }> {
        let types = new Array<any>();
        Object.assign(types, GSPElementObjectTypes);
        types = types.slice(0, 3);
        return types;
    }
}
